<template>
  <div id="app">
    <div class="header-div bg-default-color"></div>
<!--    <d-header></d-header>-->
      <router-view />
<!--    <footer-view></footer-view>-->
  </div>
</template>



<script>
import DHeader from "./components/Header";
import DFooter from "./components/Footer";

export default {
  name: 'App',
  components: {
    DHeader,
    DFooter
  },
}

</script>
<style lang="scss">
#app {
  font-family: 'Kanit',sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.header-div{
  padding-bottom: 10px;
  width: 100%;
}
</style>
